export default __webpack_public_path__ + "static/media/A_02_01_bg_v03.5f61f765.mp4";